import { StrappingEnum } from 'api';

import { formatStrapping } from '../../utils/formatStrapping/formatStrapping';
import { SelectField, type SelectFieldProps } from '../SelectField/SelectField';

const STRAPPING_OPTIONS =
  StrappingEnum &&
  Object.values(StrappingEnum).map((strapping: StrappingEnum) => ({
    label: formatStrapping(strapping),
    value: strapping,
  }));

type Props = Omit<SelectFieldProps, 'options'>;

export const StrappingSelectField = (props: Props) => {
  return <SelectField options={STRAPPING_OPTIONS} {...props} />;
};
